

export function Footer() {
    return (
        <div style={{ padding: '10px' }}>
            Mention légale à compléter
        </div>
    )
}